export const mockTenants = [
    {
      id: 1,
      name: 'John Doe',
      phoneNumber: '254712345678',
      unitNumber: 'A101',
      apartmentName: 'Green Valley Apartments',
      kraPin: 'A001234567B',
      rentAmount: 25000,
      taxAmount: 4000, // 16% of rentAmount
      totalAmount: 29000, // rentAmount + taxAmount
      paid: false,
      lastPayment: '2025-03-15'
    },
    {
      id: 2,
      name: 'Jane Smith',
      phoneNumber: '254712345679',
      unitNumber: 'B205',
      apartmentName: 'Sunshine Residences',
      kraPin: 'A001234568C',
      rentAmount: 35000,
      taxAmount: 5600,
      totalAmount: 40600,
      paid: true,
      lastPayment: '2025-06-20'
    },
    {
      id: 3,
      name: 'Michael Johnson',
      phoneNumber: '254722345680',
      unitNumber: 'C302',
      apartmentName: 'Royal Gardens',
      kraPin: 'A001234569D',
      rentAmount: 28000,
      taxAmount: 4480,
      totalAmount: 32480,
      paid: true,
      lastPayment: '2025-05-10'
    },
    {
      id: 4,
      name: 'Sarah Williams',
      phoneNumber: '254722345681',
      unitNumber: 'D104',
      apartmentName: 'Pineview Heights',
      kraPin: 'A001234570E',
      rentAmount: 32000,
      taxAmount: 5120,
      totalAmount: 37120,
      paid: false,
      lastPayment: '2025-04-05'
    },
    {
      id: 5,
      name: 'Robert Brown',
      phoneNumber: '254732345682',
      unitNumber: 'E207',
      apartmentName: 'Lakeview Towers',
      kraPin: 'A001234571F',
      rentAmount: 40000,
      taxAmount: 6400,
      totalAmount: 46400,
      paid: true,
      lastPayment: '2025-06-15'
    },
    {
      id: 6,
      name: 'Emily Davis',
      phoneNumber: '254732345683',
      unitNumber: 'F309',
      apartmentName: 'Mountain Ridge',
      kraPin: 'A001234572G',
      rentAmount: 22000,
      taxAmount: 3520,
      totalAmount: 25520,
      paid: false,
      lastPayment: '2025-03-25'
    },
    {
      id: 7,
      name: 'David Miller',
      phoneNumber: '254742345684',
      unitNumber: 'G105',
      apartmentName: 'Ocean Breeze',
      kraPin: 'A001234573H',
      rentAmount: 38000,
      taxAmount: 6080,
      totalAmount: 44080,
      paid: true,
      lastPayment: '2025-06-05'
    },
    {
      id: 8,
      name: 'Jessica Wilson',
      phoneNumber: '254742345685',
      unitNumber: 'H208',
      apartmentName: 'Sunset Villas',
      kraPin: 'A001234574J',
      rentAmount: 30000,
      taxAmount: 4800,
      totalAmount: 34800,
      paid: false,
      lastPayment: '2025-04-18'
    },
    {
      id: 9,
      name: 'Daniel Taylor',
      phoneNumber: '254752345686',
      unitNumber: 'I401',
      apartmentName: 'Parkside Residences',
      kraPin: 'A001234575K',
      rentAmount: 26000,
      taxAmount: 4160,
      totalAmount: 30160,
      paid: true,
      lastPayment: '2025-05-22'
    },
    {
      id: 10,
      name: 'Olivia Anderson',
      phoneNumber: '254752345687',
      unitNumber: 'J303',
      apartmentName: 'Hillside Apartments',
      kraPin: 'A001234576L',
      rentAmount: 34000,
      taxAmount: 5440,
      totalAmount: 39440,
      paid: false,
      lastPayment: '2025-03-30'
    },
    {
      id: 11,
      name: 'James Thomas',
      phoneNumber: '254762345688',
      unitNumber: 'K106',
      apartmentName: 'Riverside Homes',
      kraPin: 'A001234577M',
      rentAmount: 29000,
      taxAmount: 4640,
      totalAmount: 33640,
      paid: true,
      lastPayment: '2025-06-12'
    },
    {
      id: 12,
      name: 'Sophia Jackson',
      phoneNumber: '254762345689',
      unitNumber: 'L209',
      apartmentName: 'Forest View',
      kraPin: 'A001234578N',
      rentAmount: 31000,
      taxAmount: 4960,
      totalAmount: 35960,
      paid: true,
      lastPayment: '2025-05-28'
    },
    {
      id: 13,
      name: 'Benjamin White',
      phoneNumber: '254772345690',
      unitNumber: 'M402',
      apartmentName: 'Cityscape Towers',
      kraPin: 'A001234579P',
      rentAmount: 42000,
      taxAmount: 6720,
      totalAmount: 48720,
      paid: false,
      lastPayment: '2025-04-10'
    },
    {
      id: 14,
      name: 'Isabella Harris',
      phoneNumber: '254772345691',
      unitNumber: 'N304',
      apartmentName: 'Garden Apartments',
      kraPin: 'A001234580Q',
      rentAmount: 27000,
      taxAmount: 4320,
      totalAmount: 31320,
      paid: true,
      lastPayment: '2025-06-18'
    },
    {
      id: 15,
      name: 'William Martin',
      phoneNumber: '254782345692',
      unitNumber: 'O107',
      apartmentName: 'Skyline Heights',
      kraPin: 'A001234581R',
      rentAmount: 36000,
      taxAmount: 5760,
      totalAmount: 41760,
      paid: false,
      lastPayment: '2025-03-22'
    },
    {
      id: 16,
      name: 'Charlotte Thompson',
      phoneNumber: '254782345693',
      unitNumber: 'P210',
      apartmentName: 'Valley View',
      kraPin: 'A001234582S',
      rentAmount: 33000,
      taxAmount: 5280,
      totalAmount: 38280,
      paid: true,
      lastPayment: '2025-05-15'
    },
    {
      id: 17,
      name: 'Alexander Garcia',
      phoneNumber: '254792345694',
      unitNumber: 'Q403',
      apartmentName: 'Sunrise Apartments',
      kraPin: 'A001234583T',
      rentAmount: 24000,
      taxAmount: 3840,
      totalAmount: 27840,
      paid: false,
      lastPayment: '2025-04-28'
    },
    {
      id: 18,
      name: 'Amelia Martinez',
      phoneNumber: '254792345695',
      unitNumber: 'R305',
      apartmentName: 'Harbor Lights',
      kraPin: 'A001234584U',
      rentAmount: 37000,
      taxAmount: 5920,
      totalAmount: 42920,
      paid: true,
      lastPayment: '2025-06-08'
    },
    {
      id: 19,
      name: 'Mason Robinson',
      phoneNumber: '254702345696',
      unitNumber: 'S108',
      apartmentName: 'Meadowlands',
      kraPin: 'A001234585V',
      rentAmount: 28000,
      taxAmount: 4480,
      totalAmount: 32480,
      paid: false,
      lastPayment: '2025-03-18'
    },
    {
      id: 20,
      name: 'Evelyn Clark',
      phoneNumber: '254702345697',
      unitNumber: 'T211',
      apartmentName: 'Highland Park',
      kraPin: 'A001234586W',
      rentAmount: 39000,
      taxAmount: 6240,
      totalAmount: 45240,
      paid: true,
      lastPayment: '2025-05-30'
    }
  ];